import React, { useMemo } from 'react';
import { saralPurple } from '../../../utils/constants';
import './_changeLog.scss';

const ChangeLogTag = ({ tag }) => {
  const bgColor = useMemo(() => {
    switch (tag) {
      case 'newFeature':
        return '#FFF6FB';
      case 'enhancements':
        return '#F1F7FF';
      case 'bugFix':
        return '#FEFCE8';
      case 'performance':
        return '#00B89C';
      case 'design':
        return '#F7F3FD';
      default:
        return saralPurple;
    }
  }, [tag]);

  const color = useMemo(() => {
    switch (tag) {
      case 'newFeature':
        return '#FF65BC';
      case 'enhancements':
        return '#3D8BF7';
      case 'bugFix':
        return '#CA8A04';
      case 'performance':
        return '#00B89C';
      case 'design':
        return '#7F38E9';
      default:
        return '#ffffff';
    }
  }, [tag]);

  const text = useMemo(() => {
    switch (tag) {
      case 'newFeature':
        return 'New Feature';
      case 'enhancements':
        return 'Enhancements';
      case 'bugFix':
        return 'Bug Fixes';
      case 'performance':
        return 'Performance';
      case 'design':
        return 'Design/UI';
      default:
        return tag;
    }
  }, [tag]);

  return (
    <div className="change-log-tag-container" style={{ backgroundColor: bgColor, color }}>
      {text}
    </div>
  );
};

export default ChangeLogTag;
